import PropTypes from 'prop-types';
import { commonPropTypes, } from '../../interfaces/commonProps';
import { spacingPropTypes, } from '../../interfaces/layoutProps';
export var PaginationVariant;
(function (PaginationVariant) {
    PaginationVariant["compact"] = "compact";
    PaginationVariant["extended"] = "extended";
    PaginationVariant["minimal"] = "minimal";
    PaginationVariant["minimalWithLabels"] = "minimalWithLabels";
    PaginationVariant["normal"] = "normal";
})(PaginationVariant || (PaginationVariant = {}));
export const paginationVariants = [
    'compact',
    'extended',
    'minimal',
    'minimalWithLabels',
    'normal',
];
export const StartEllipsis = 'start-ellipsis';
export const EndEllipsis = 'end-ellipsis';
export const paginationPropTypes = {
    children: PropTypes.func,
    count: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    onChange: PropTypes.func,
    variant: PropTypes.oneOf(paginationVariants).isRequired,
    ...commonPropTypes,
    ...spacingPropTypes,
};
//# sourceMappingURL=Pagination.types.js.map